import { createApp, onMounted } from 'vue'

const app = createApp({
  setup() {
    const scrollWindow = () => {
      const windowHeight = window.innerHeight
      scrollTo(0, windowHeight + 1)
    }
    onMounted(() => {
      const mainVisual: HTMLElement | null = document.getElementById('mainVisual')
      if (mainVisual) {
        window.addEventListener('scroll', () => {
          const scrollHeight = document.documentElement.scrollTop
          if (scrollHeight > mainVisual!.clientHeight) {
            mainVisual?.classList.add('fixed')
          } else {
            mainVisual?.classList.remove('fixed')
          }
        })
      }
    })
    return { scrollWindow }
  }
})
if (document.getElementById('mainVisual') != null) {
  app.mount('#mainVisual')
}
